// The table's keys (design 8 item 3) and what they must leave alone.

/** What takes Enter and Space for itself when it has the focus. */
export const CONTROLS = "a, button, summary, select, textarea, input, [role=button]";

/** A dialog is open over the page: the keys are its own. */
export const anyDialog = (): boolean => !!document.querySelector(".dialog-backdrop");

/** Whether a key is the table's to act on: never while a dialog is open, and Enter and Space belong to a focused control. They used to discard the
 *  drawn tile from a focused Riichi button, or skip a call from a focused Pon (UX review 2026-11-02). */
export function tableKey(key: string, onControl: boolean, dialogOpen: boolean): boolean {
  if (dialogOpen) return false;
  return !(onControl && (key === "enter" || key === " "));
}

/** The button a key stands for at a table without assists. R is riichi on the seat's own turn and ron on a discard: the Riichi button is
 *  ruled on when pressed empty, and the key has to be the button. */
export function openButtonOfKey(key: string, ownTurn: boolean): string | null {
  switch (key) {
    case "t":
      return "TSUMO";
    case "r":
      return ownTurn ? "DECLARE_RIICHI" : "RON";
    case "k":
      return "OPEN_KAN";
    case "p":
      return "PON";
    case "c":
      return "CHI";
    default:
      return null;
  }
}
